import { render, staticRenderFns } from "./FormBoolean.vue?vue&type=template&id=656b34fe"
import script from "./FormBoolean.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormBoolean.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports